import { render } from "./ItemFilterSelect.vue?vue&type=template&id=6e895c7c"
import script from "./ItemFilterSelect.vue?vue&type=script&lang=ts"
export * from "./ItemFilterSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script